export const iconFontAwesomeHumanitarianPlaneCircleXmark = (
	<i className="fa-solid fa-plane-circle-xmark"></i>
);
